import axios from '../../axios'

// 就业地域管理端增删查改接口

// 新增就业地域
export const addRegion = (data) => {
    return axios({
        url: '/api/data/wish/region',
        method: 'POST',
        data
    })
}

// 获取就业地域详情
export const getRegionInfo = (data) => {
    return axios({
        url: '/api/data/wish/region/info',
        method: 'GET',
        data
    })
}

// 修改就业地域信息
export const editRegion = (data) => {
    return axios({
        url: '/api/data/wish/region',
        method: 'PUT',
        data
    })
}

// 删除就业地域信息
export const deleteRegion = (data) => {
    return axios({
        url: '/api/data/wish/region',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索就业地域信息列表
export const searchRegionList = (data) => {
    return axios({
        url: '/api/data/wish/region',
        method: 'GET',
        data
    })
}

// 根据关键字获取专业列表
export const getProfListByKey = (data) => {
    return axios({
        url: '/api/data/wish/search/prof/detail',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/region.js